export enum Data {
    SubCategories = 'subCategories'
}

export enum ExtractType {
    FullData = 'FullData',
    Indicator = 'IndicatorData',
    Category = 'CategoryData',
    SubCategory = 'SubCategoryData'
}

export enum EntityType {
    Indicator = 'Indicator',
    Category = 'Category',
    SubCategory = 'SubCategory'
}

export enum CategoryField {
    Name = 'CategoryName',
    Description = 'description',
    SortOrder = 'sortOrder'
}

export enum SubCategoryField {
    Name = 'SubcategoryName',
    Description = 'SubcatDescription',
    SortOrder = 'SubcatSortOrder'
}

export enum IndicatorDetailFields {
    Name = 'name',
    Description = 'description',
    SourceDate = 'sourceDate',
    ValueType = 'valueType',
    SourceId = 'sourceId',
    WebAddress = 'webAddress',
    Reference = 'reference',
    FrequencyTypeId = 'frequencyTypeId',
    Order = 'order',
    SortOrder = 'sortOrder'
}

export enum IndicatorCountryListField {
    LocationName = 'locationName',
    Value = 'value'
}

export enum LinkType {
    Parent = 'parent',
    Child = 'child',
    NoLink = ''
}

export enum WhatsNewField {
    Name = 'name',
    Description = 'description',
    SortOrder = 'sortOrder',
    Link = 'link',
    Video = 'video',
    Image = 'image'
}

export enum ApiInitiator {
    PreviewData = 'PreviewData',
    MasterData = 'MasterData',
    ArchiveList = 'ArchiveList'
}
